export default "__VITE_ASSET__pjpEmd8X__"